import moment from "jalali-moment";
import {Col} from "react-bootstrap";
import React ,{Component} from "react";
import ShowMoreText from "react-show-more-text";

class AuctionInfo extends Component {
    prepareTag(data) {
        let div = document.createElement('div');
        div.innerHTML = data;
        div = this.removeStyleRecursively(div);
        return div.innerHTML;
    }

    removeStyleRecursively(element) {
        element.removeAttribute('style');
        let children = element.children;
        for(let i = 0; i < children.length; i++) {
            this.removeStyleRecursively(children[i]);
        }
        return element;
    }

    render() {
        const current_date = moment()
            .locale('fa')
            .format('YYYY/MM/DD');

        const start_date = moment(this.props.auctionInfo.start_date, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');

        const end_date = moment(this.props.auctionInfo.end_date, 'YYYY/MM/DD')
            .locale('fa')
            .format('YYYY/MM/DD');

        let date_diff = moment(end_date, 'jYYYY/jMM/jDD')
            .diff(moment(current_date, 'jYYYY/jMM/jDD'), 'days');

        let remaining_days = null;
        if (date_diff === 0) {
            remaining_days = 'امروز';
        } else if (date_diff > 0) {
            remaining_days = date_diff.toString() + ' روز مانده';
        }

        let data = '';
        if (this.props.auctionInfo.data) {
            data =
                <ShowMoreText
                    // Default options
                    lines={1}
                    more={<span className='main-color'>نمایش بیشتر</span>}
                    less={<span className='main-color'>نمایش کمتر</span>}
                    anchorClass='anchor'
                    /*onClick={}*/
                    expanded={false}
                    /*width={280}*/
                >
                    <div dangerouslySetInnerHTML={{ __html: this.props.auctionInfo.data }} />
                </ShowMoreText>;
        }

        let reforms = '';
        if (this.props.auctionInfo.reforms) {
            reforms = <Col md={12}><div dangerouslySetInnerHTML={{ __html: this.props.auctionInfo.reforms }} /></Col>;
        }

        let forms = '';
        if (this.props.auctionInfo.forms) {
            forms = <Col md={12}><div dangerouslySetInnerHTML={{ __html: this.props.auctionInfo.forms }} /></Col>;
        }

        return(
            <>
                <header className="proj-header1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="caption md-mb50">
                                    <h1 className='fz-40' style={{lineHeight: '1.5'}}>{this.props.auctionInfo.title}</h1>
                                </div>
                            </div>
                            <div className="col-lg-6 d-flex justify-content-start align-items-start">
                                <div className="info row">
                                    <div className="col-sm-6">
                                        <div className="item mb-30">
                                            <h6 className="fz-16">آغاز</h6>
                                            <span className="sub-title ls1">{start_date}</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="item mb-30">
                                            <h6 className="fz-16">کد مزایده</h6>
                                            <span className="sub-title ls1">{this.props.auctionInfo.code}</span>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="item mb-30">
                                            <h6 className="fz-16">پایان</h6>
                                            <span className="sub-title ls1">{end_date} {remaining_days ? ' (' + remaining_days + ')' : ''}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <section className="pt-30 pb-30">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="text" id="parent-tag">
                                    <p className="mb-50">{data}</p>
                                    <div className="row">
                                        {reforms}
                                        {forms}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section></>
        );
    }
}

export default AuctionInfo;
